<template>
    <el-dialog :visible.sync="dialogVisible" title="" width="60%" :before-close="handleClose">
        <template #content>
            <el-form :model="form" label-width="120px">
                <el-form-item label="主卖ASIN">
                    <el-input v-model="form.main_seller_asin" placeholder="请输入主卖ASIN" size="mini" style="width: 200px"></el-input>
                </el-form-item>
                <el-form-item label="SKAG关键词">
                    <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap">
                        <el-input v-model="skagInput" placeholder="输入关键词后点击添加" size="mini" style="width: 220px"></el-input>
                        <el-button size="mini" type="primary" @click="addSkag">添加</el-button>
                        <div style="display:flex;flex-wrap: wrap;gap:6px">
                            <el-tag v-for="(k,i) in skagList" :key="i" closable @close="removeSkag(i)">{{k}}</el-tag>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="非主卖ASIN">
                    <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap">
                        <el-input v-model="notMainInput" placeholder="输入ASIN后点击添加(可为空)" size="mini" style="width: 220px"></el-input>
                        <el-button size="mini" type="primary" @click="addNotMain">添加</el-button>
                        <div style="display:flex;flex-wrap: wrap;gap:6px">
                            <el-tag v-for="(a,i) in notMainList" :key="i" closable type="info" @close="removeNotMain(i)">{{a}}</el-tag>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </template>

        <template #footer>
            <div class="dialog-footer" style="display: flex;justify-content: end">
                <el-button @click="dialogVisible = false" size="mini">关闭</el-button>
                <el-button type="primary" @click="updateFunc" size="mini">更新</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys'

export default {
    name: 'completedProductionDialog',
    data() {
        return {
            dialogVisible: false,
            form: {
                main_seller_asin: '',
            },
            skagInput: '',
            skagList: [],
            notMainInput: '',
            notMainList: [],
        }
    },
    methods: {
        updateFunc(){

            const skagStr = this.skagList.join(',')
            const notMainStr = this.notMainList.join(',')

            api.producer_finish_production_link({
                id: this.tempData.id,
                main_seller_asin: this.form.main_seller_asin,
                not_main_seller_asins: this.notMainList,
                skag_keywords: this.skagList
            }).then((res) => {
                if (res.success) {
                    this.$message.success(res.data)
                    this.handleClose(true)
                } else {
                    this.$message.error(res.message)
                }
            }).finally(() => {
                this.loading = false
            })

        },
        // 关闭弹窗
        handleClose(isshow = false) {
            const done = typeof isshow === 'function' ? isshow : null
            const shouldEmit = typeof isshow === 'function' ? false : !!isshow
            this.dialogVisible = false
            this.loading = false
            this.formData = {}
            this.resetForm()
            this.tempData = {}
            this.$emit('close-callback', shouldEmit)
            if (done) done()
        },
        showModal(data) {
            this.tempData = JSON.parse(JSON.stringify(data))
            this.dialogVisible = true
        },
        addSkag() {
            const v = (this.skagInput || '').replace(/，/g, ',').trim()
            if (!v) return
            v.split(',').map(s=>s.trim()).filter(Boolean).forEach(s=>{
                if (!this.skagList.includes(s)) this.skagList.push(s)
            })
            this.skagInput = ''
        },
        removeSkag(index){
            this.skagList.splice(index,1)
        },
        addNotMain(){
            const v = (this.notMainInput || '').replace(/，/g, ',').trim()
            if (!v) return
            v.split(',').map(s=>s.trim()).filter(Boolean).forEach(s=>{
                if (!this.notMainList.includes(s)) this.notMainList.push(s)
            })
            this.notMainInput = ''
        },
        removeNotMain(index){
            this.notMainList.splice(index,1)
        },
        resetForm() {
            this.form = {
                main_seller_asin: '',
            }
            this.skagInput = ''
            this.skagList = []
            this.notMainInput = ''
            this.notMainList = []
        }
    }
}
</script>

<style scoped lang="scss">
.mt-4 {
    margin-top: 1rem;
}
.mb-2 {
    margin-bottom: 0.5rem;
}
.text-center {
    text-align: center;
}
.text-gray-500 {
    color: #909399;
}
.text-danger {
    color: #f56c6c;
}
</style>
